export default {
	forStudent: 'Para Estudiante ',
	windows: 'Airclass para Windows',
	mac: 'AirClass para Mac',
	iphone: 'Airclass para iphone',
	android: 'AirClass para Android',
	download: 'Descargar',
	scan: 'Escanear para descargar usuario de iphone',
	scanA: 'Escanear para descargar usurario de Android',
	scan1: 'Escanear el código ',
	toDownload: 'para descargar',
	newToDownload: 'for Android',
	or: 'o',
	clickHere: 'haga clic',
	h2: 'Airclass uno a uno',
	p: 'Mandar resultados rápidamente Tutoría en línea de Airclass',
	span1: 'Ir a la tienda de aplicaión',
	ios: 'IOS ',
	play: 'Ir a Google Play o',
	newPlay: 'Go to download',
	play1: 'Android',
	macTitle: 'MAC',
	windowsTitle: 'WINDOWS',
	forTeacher: 'Para Profesor',
	guide: 'Descargar Guía de Usuario',
	pdf_url: 'https://web-data.zmlearn.com/doc/tWWwSu81Ucjdmadijv5XRu/App%20intstroduction.pdf',
};
